

kits = {
  products: document.querySelectorAll('[data-option-product]'),
  colors: document.querySelectorAll('.prod-option input[name="color"]'),
  setPrice: function () {
    const priceEl = document.querySelector('[data-update-price-main] .price');
    let sale_price = 0;
    let price = 0;
    window.kitProducts.forEach(product => {
      sale_price += product.variants[0].price != product.variants[0].sale_price ? product.variants[0].sale_price : product.variants[0].price;
      price += product.variants[0].price;
    });
    priceEl.innerHTML = `${price > sale_price ? `<del>${window.store.formatMoney(price)}</del>` : '' }<ins>${window.store.formatMoney(sale_price)} <span>à vista</span></ins>`;
  },
  setQuantities: function () {
    const maxQuantity = document.querySelector('[data-max-quantity]');
    if (maxQuantity) maxQuantity.setAttribute('data-max-quantity', 999);
  },
  setButton: function () {
    const { products } = this;
    const button = document.querySelector('.add-to-cart-button');
    if (button) button.addEventListener('click', () => {
      let count = document.querySelector('[data-cart-count-attr]').getAttribute('data-cart-count-attr');
      if (Number(count) > 0) {
        console.log('Tem carrinho');
        vnda.loadCartPopup(function (html) {
          let cart = html ? JSON.parse(html) : null;
          window.store.addItemKit(products, null, cart);
        });
      } else {
        console.log('Primeira adição');
        window.store.addItemKit(products, null, null);
      }
    });
  },
  updateProducts: function (products) {
    products.forEach((product, i) => {
      const sku = product.querySelector('input[name="sku"]');
      const title = product.querySelector('[data-attr2-result]');

      sku.value = '';
      
      let sizes = product.querySelectorAll('input[type="radio"]');
      let sizeSelected = false;
      if (sizes.length > 0) sizes.forEach(size => {
        size.checked = false;

        let label = size.nextElementSibling;
        label.classList.add('disable');

        window.kitProducts[i].variants.forEach(variant => {
          if (variant.properties.property2.value == size.value && variant.available) {
            label.classList.remove('disable');
            if (!sizeSelected) {
              sizeSelected = true;
              size.checked = true;
              size.nextElementSibling.click();
              sku.value = variant.sku;
            }
          }
        });
      });
    });
  },
  handleSizesChange: function () {
    const { products } = this;
    products.forEach((product, i) => {
      const sku = product.querySelector('input[name="sku"]');
      const title = product.querySelector('[data-attr2-result]');


      let sizes = product.querySelectorAll('input[type="radio"]');
      if (sizes.length > 0) sizes.forEach(size => {
        size.addEventListener('change', () => {
          let value;
          let color = document.querySelector('.prod-option input[name="color"]:checked');
          window.kitProducts[i].variants.forEach(variant => {
            if (variant.properties.property2.value == size.value && variant.available) value = variant.sku;
          });
          sku.value = value ? value : '';
        });
      });
    });
  },
  handleColorsChange: function () {
    const { colors, products, updateProducts } = this;
    if (colors.length > 0) colors.forEach(color => {
      color.addEventListener('change', () => {
        updateProducts(color, products);
      });
    });
  },
  checkFirstColor: function () {
    const { colors, products, updateProducts } = this;
    if (colors[0]) {
      colors[0].checked = true;
      colors[0].nextElementSibling.click();
      updateProducts(colors[0], products);
    }
  },
  init: function () {
    const { products } = this;
    if (window.kitProducts) {
      this.setPrice();
      // this.setQuantities();
      this.updateProducts(products);
      this.setButton();
      
      this.handleSizesChange();
      this.handleColorsChange();
  
      this.checkFirstColor();
    }
  }
}

kits.init();
